import {
  calcItemsPrice,
  calcShippingPrice,
  calcTaxPrice,
} from './pricing';


export const addDecimals = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

// NOTE: the code below has been changed from the course code to fix an issue
// with type coercion of strings to numbers.
// Our addDecimals function expects a number and returns a string, so it is not
// correct to call it passing a string as the argument.

export const updateCart = (state) => {
  // Prices are whole New Taiwan Dollars. Rules live in ./pricing.js (mirrors
  // backend/utils/calcPrices.js, which is the source of truth for orders).
  const itemsPrice = calcItemsPrice(state.cartItems);
  state.itemsPrice = itemsPrice;

  // Carrier flat rate (中華郵政 150 / 黑貓 250), free at >= NT$1,000.
  // null until a carrier is chosen, so the UI can ask the shopper to pick one.
  const shippingPrice = calcShippingPrice(itemsPrice, state.shippingMethod?.id);
  state.shippingPrice = shippingPrice;

  // Tax: 5% of the items subtotal only (shipping excluded)
  const taxPrice = calcTaxPrice(itemsPrice);
  state.taxPrice = taxPrice;

  // Total (shipping counted as 0 until a carrier is selected)
  state.totalPrice = itemsPrice + (shippingPrice ?? 0) + taxPrice;

  // Save the cart to localStorage
  localStorage.setItem('cart', JSON.stringify(state));

  return state;
};
